import colors from "../../../common/styles/colors";

export const styles = {
  dialogContainer: {
    zIndex: "9999999 !important" as any,
    padding: "10px",
    width: "100%"
  },
  dialogTitleContainer: {
    paddingBottom: "1px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  dialogTitle: {
    fontWeight: "bold",
    fontSize: "24px",
    display: "block"
  },
  dialogCloseButton: {
    cursor: "pointer",
    marginTop: "1",
    fontSize: "25px"
  },
  dialogAlert: {
    marginTop: "20px"
  },
  dialogContentTable: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "600px"
  },
  dialogContentTableColumnFirstItem: {
    borderRadius: "5px 0 0 5px",
    padding: "15px",
    border: `2px ${colors.grey[100]} solid`,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    wordBreak: "break-all",
    flex: 1
  },
  dialogContentTableColumn: {
    padding: "15px",
    border: `2px ${colors.grey[100]} solid`,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    borderLeft: "unset",
    wordBreak: "break-all",
    flex: 1
  },
  dialogContentTableColumnLastItem: {
    padding: "15px",
    border: `2px ${colors.grey[100]} solid`,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    borderLeft: "unset",
    borderRadius: "0 5px 5px 0",
    wordBreak: "break-all",
    flex: 1
  },
  dialogContentScanner: {
    backgroundColor: colors.grey[200],
    padding: "30px 0 10px 0"
  },
  tableColumnTitle: {
    fontSize: "14px"
  },
  tableColumnDesc: {
    fontSize: "15px",
    fontWeight: 600
  },
  companyDialogTitle: {
    fontSize: 22,
    fontWeight: 600,
    paddingBottom: 1
  },

  companyDialogCloseButton: {
    cursor: "pointer",
    marginTop: 1,
    fontSize: 25,
    position: "absolute",
    top: 16,
    right: 16
  },

  companyDialogContent: {
    paddingTop: 0.5
  },

  companyDialogLoadingBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 120
  },

  companyDialogNoAdminsMessage: {
    marginTop: 2,
    fontWeight: 400
  },

  companyDialogSubtitle: {
    marginBottom: 2
  },

  companyDialogActions: {
    paddingRight: 3,
    paddingBottom: 4
  },

  companyDialogCloseBtn: {
    minWidth: 90,
    textTransform: "none",
    fontWeight: 600,
    fontSize: 14
  }
};
